const DEFAULT_THRESHOLD = 8;

function getThresholdNumber(inputEl) {
  const raw = inputEl?.value;
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : DEFAULT_THRESHOLD;
}

function setGroupHighlighted(groupEl, enabled) {
  if (enabled) {
    groupEl.classList.add("sas-tt-credit-overload");
    return;
  }

  groupEl.classList.remove("sas-tt-credit-overload");
}

// Highlight is tied only to credit hours vs threshold, never to display state.
// Filter-driven `display:none` (Alpine `x-show`) hides the row visually anyway,
// and keeping the class on hidden groups means it stays put when filters reveal
// them again — no flicker on each filter input.
function applyHighlighting({ enabled, threshold }) {
  const groups = document.querySelectorAll(".sas-tt-faculty-credit-group[data-credit-hours]");
  groups.forEach((groupEl) => {
    const creditHours = Number.parseFloat(groupEl.dataset.creditHours);
    const shouldHighlight = enabled && Number.isFinite(creditHours) && creditHours > threshold;
    setGroupHighlighted(groupEl, shouldHighlight);
  });
}

export default function initHighlightOverloadFacultyCredits() {
  const controlsRoot = document.querySelector("[data-sas-tt-credit-highlight-controls]");
  if (!controlsRoot) return;

  const toggle = controlsRoot.querySelector("[data-sas-tt-credit-highlight-toggle]");
  const thresholdInput = controlsRoot.querySelector("[data-sas-tt-credit-threshold]");
  const track = controlsRoot.querySelector("[data-sas-tt-credit-toggle-track]");
  const knob = controlsRoot.querySelector("[data-sas-tt-credit-toggle-knob]");
  if (!toggle || !thresholdInput) return;

  if (!thresholdInput.value) thresholdInput.value = String(DEFAULT_THRESHOLD);

  const refresh = () => {
    if (knob) {
      knob.classList.toggle("translate-x-5", Boolean(toggle.checked));
      knob.classList.toggle("translate-x-0", !toggle.checked);
    }
    if (track) {
      track.classList.toggle("bg-green-500", Boolean(toggle.checked));
      track.classList.toggle("bg-slate-300", !toggle.checked);
    }
    applyHighlighting({
      enabled: Boolean(toggle.checked),
      threshold: getThresholdNumber(thresholdInput),
    });
  };

  toggle.addEventListener("change", refresh);
  thresholdInput.addEventListener("input", refresh);
  thresholdInput.addEventListener("change", refresh);

  refresh();
}

